import type { ErpEnvironment } from '@/shared/erp/erpEnvironment';
import { claimflowApiClient } from './claimflowApiClient';

/**
 * The lean, tenant-safe registry payload exposed to claimflow users by
 * `GET /claimflow/erp/registries` — never the admin `ErpRegistry` shape
 * (no `auth_config`, no headers, retry or rate-limit data). `base_url` is
 * included on purpose: the non-production banner shows staff which ERP host
 * they are hitting. Feeds that banner.
 */
export interface ClaimflowErpRegistry {
  slug: string;
  name: string;
  base_url: string;
  environment: ErpEnvironment | null;
  is_main: boolean;
}

interface ClaimflowErpRegistriesResponse {
  data: ClaimflowErpRegistry[];
}

export const erpRegistriesService = {
  /**
   * The current tenant's active ERP registries, main registry first.
   *
   * Auth token and `X-Tenant-ID` are added by `claimflowApiClient`.
   */
  async fetchAll(): Promise<ClaimflowErpRegistry[]> {
    const response =
      await claimflowApiClient.get<ClaimflowErpRegistriesResponse>(
        '/claimflow/erp/registries',
      );
    return response.data.data;
  },
};
